import React, { useState, useContext } from "react";
import styled from "styled-components";
import { TextField, Icon } from "@material-ui/core";
import CopyrightIcon from "@material-ui/icons/Copyright";
import SendIcon from "@material-ui/icons/Send";
import { Button } from "../../components/ui/forms/Button";
import Spinner from "../../components/ui/Spinner";
import LogoLogin from "../../assets/LogoLogin";
import { UserContext } from "../../contexts/UserContext";
import { Copyright } from "./Copyright";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const { forgotPassword } = useContext(UserContext);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    await forgotPassword(email);

    setLoading(false);
  };

  const handleChange = (event) => {
    const { value } = event.target;
    setEmail(value);
  };

  return (
    <Container>
      <Box>
        <LogoLogin />
        <form onSubmit={handleSubmit}>
          {loading ? (
            <Spinner colour="secondary" />
          ) : (
            <>
              <TextField
                type="email"
                name="email"
                onChange={handleChange}
                value={email}
                label="Your Email"
                size="medium"
                required
              />
              <h3>
                Please check your junk/spam folders if you don't receive the
                email
              </h3>
              <FormButtons>
                <Button
                  type="submit"
                  colour="secondary"
                  className="margin-icon"
                >
                  <SendIcon style={Iconstyles} /> Send Reset Link to Email
                </Button>
              </FormButtons>
            </>
          )}
        </form>
        <Icon icon={<CopyrightIcon />} style={{ marginRight: "1rem" }} />
        <Copyright />
      </Box>
    </Container>
  );
};

const Iconstyles = {
  FontSize: "17px",
  marginRight: "5px",
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  max-width: 320px;
  .logo {
    max-width: 180px;
    margin-bottom: 40px;
    margin-top: -80px;
  }
`;

const FormButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0 80px 0;
`;

export default ForgotPassword;
